import { arrayMove, JsonObject } from '@/lib/helpers';
import { getTimestamp } from '@/lib/date-helpers';
import { TileMetaModel, TileModel } from './tile.model';

export type TileMeta = {
  tileId: string;
};

export class HomeModel {
  favorites: TileMetaModel[];
  recent: TileMetaModel[];

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof HomeModel, unknown>;
    this.favorites = Array.isArray(data.favorites)
      ? (data.favorites as JsonObject[]).map((row) => new TileMetaModel({ ...row }))
      : [];
    this.recent = Array.isArray(data.recent)
      ? (data.recent as JsonObject[]).map((row) => new TileMetaModel({ ...row }))
      : [];
  }

  addFavorite(tile: TileModel): void {
    this.removeFavorite(tile.tileId);
    const index = this.favorites.findIndex(({ tileId }) => tileId === tile.tileId);

    if (index === -1) {
      const favoriteTile = new TileMetaModel({
        ...tile._props,
        createdAt: getTimestamp(new Date()) || 0,
      });
      this.favorites.unshift(favoriteTile);
    }
  }

  removeFavorite(tileId: string): void {
    const index = this.favorites.findIndex(({ tileId: recentTileId }) => recentTileId === tileId);
    if (index > -1) {
      this.favorites.splice(index, 1);
    }
  }

  moveFavorite(tileId: string, targetTileId: string): void {
    const index = this.favorites.findIndex(
      ({ tileId: favoriteTileId }) => favoriteTileId === tileId
    );
    const targetIndex = this.favorites.findIndex(
      ({ tileId: favoriteTileId }) => favoriteTileId === targetTileId
    );

    if (index > -1 && targetIndex > -1) {
      this.favorites = arrayMove(this.favorites, index, targetIndex);
    }
  }

  addRecent(tile: TileModel): void {
    this.removeRecent(tile.tileId);
    const index = this.recent.findIndex(({ tileId }) => tileId === tile.tileId);

    if (index === -1) {
      const createdAt = getTimestamp(new Date()) || 0;
      const recentTile = new TileMetaModel({
        ...tile._props,
        createdAt,
      });
      this.recent.unshift(recentTile);
    }

    if (this.recent.length > 100) {
      this.recent = this.recent.slice(0, 100);
    }
  }

  removeRecent(tileId: string): void {
    const index = this.recent.findIndex(({ tileId: recentTileId }) => recentTileId === tileId);
    if (index > -1) {
      this.recent.splice(index, 1);
    }
  }
}
